var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitFork = function SvgGitFork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1040FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 20a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 0v-4m-5-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 0v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2m0 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};
export default SvgGitFork;